var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn-lang center",on:{"click":function($event){return _vm.changeLanguage()}}},[_c('span',[_vm._v(_vm._s(_vm.btn))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }